import type { TodoStatus } from "@/components/MyStudentDetail/FilterableTodosSection/types";
import type { TodoLockReason } from "./types";

export const TODO_LOCK_REASONS = {
  editNotAllowed: "editNotAllowed",
  dueDatePassed: "dueDatePassed",
} as const;

// A to-do in one of these statuses has not been accepted yet, so it can always be (re)submitted.
export const OPEN_FOR_SUBMISSION_STATUSES: TodoStatus[] = ["Not Submitted", "Requires a Change"];

export const TODO_DUE_DATE_FORMAT = "yyyy-MM-dd";

export const TODO_LOCK_MESSAGES: Record<TodoLockReason, string> = {
  [TODO_LOCK_REASONS.dueDatePassed]:
    "The fields below cannot be edited anymore because the due date for this to-do has passed.",
  [TODO_LOCK_REASONS.editNotAllowed]:
    "This form has already been submitted. Submissions are final and cannot be edited or resubmitted.",
};
